import { List, Map, fromJS } from 'immutable';

const NUMBER_OF_RECENT_EVENTS = 5;

export function push(state, { event, competition }) {
    let recent = state.get('recent') || List();

    recent = recent
        .filter(x => x.get('id') !== event.id)
        .unshift(fromJS({
            id: event.id,
            name: event.name,
            sport: event.sport,
            competition: event.competition,
            competitionName: competition && competition.name
        }));

    recent = recent.slice(0, NUMBER_OF_RECENT_EVENTS);

    return state.set('recent', recent);
}
